/**推荐模块 */
import request from '../request/http';
/**查询推荐课程 */
export function QueryRecommendCourse(data){
    return request({
        url: '/sp/recommendData/queryRecommendCourse',
        method: 'post',
        data
    })
}
/**查询推荐资源 */
export function QueryRecommendResData(data){
    return request({
        url: '/sp/recommendData/queryRecommendResData',
        method: 'post',
        data
    })
}
/**查询推荐仿真软件 */
export function QueryRecommendSoftware(data){
    return request({
        url: '/sp/recommendData/queryRecommendSoftware',
        method: 'post',
        data
    })
}